import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './routes/MyContextProvider';

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/login_logout" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;